import React, { useState, useEffect } from "react";
import {
  Page,
  Hero,
  HeroImage,
  MainSection,
  Container,
  LogoImage,
  Subtitle,
  ModulesGrid,
} from "./LandingPageContainer.styled";
import HeaderComponent from "../../components/LandingPage/HeaderComponent/HeaderComponent";
import CardComponent from "../../components/LandingPage/CardComponent/CardComponent";
import BannerHome from "../../assets/svg/banner-home-2.0.svg";
import {
  ALL_HOME_CONFIGURATIONS,
} from "../../GraphQL/Queries";
import { useLazyQuery } from "@apollo/client";
import { cookie } from "../../util/JWTCookie";
import { useHistory } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import PortalModal from "../../Portals/PortalModal";
import VideoComponent from "../../components/LandingPage/VideoComponent/VideoComponent";
import tnsLogo from "../../assets/svg/tns-logo-2.0.svg";
import { ai } from "../../helpers/appInsights";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

const LandingPageContainer = ({
  isAuthenticated,
  userInfo,
  handleLogin,
  handleLogOut,
}) => {
  const history = useHistory();
  const [moduleButtons, setModuleButtons] = useState([]);
  const [videoSource, setVideoSource] = useState();

  const [runQueryAllHomeConfigurations, { loading: loadingConfiguration }] =
    useLazyQuery(ALL_HOME_CONFIGURATIONS, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.allConfigurationValues) {
          const homeConfigurations = data.allConfigurationValues.filter(
            (record) => record["section"] === "Home"
          );
          const moduleButtonArr = homeConfigurations.filter(
            (record) => record["keyConfigurationValues"].includes("BUTTON_HOME")
          );
          setModuleButtons(moduleButtonArr);
        }
      },
    });

  const getTokenApp = async (data) => {
    const opts = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + data.accessToken,
      },
    };

    try {
      const response = await fetch(process.env.LOGIN_URL, opts);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const text = await response.text();
      return text;
    } catch (error) {
      console.error('Error fetching token:', error);
      throw error;
    }
  };

  const handleToken = async (data) => {
    const response = await getTokenApp(data);
    const resObj = JSON.parse(response);
    if (resObj && resObj?.accessToken) {
      cookie.set("TrustSafety", resObj);
      history.push("/Home");
    } else {
      handleLogOut();
      NotificationManager.warning("User does not exist", "", 5000);
    }
  };

  const handleShowVideo = (video) => {
    setVideoSource(video);
  };

  useEffect(() => {
    runQueryAllHomeConfigurations({ context: { clientName: "LinkUsers" } });
  }, []);

  useEffect(() => {
    if (isAuthenticated && userInfo) {
      (async () => {
        try {
          await handleToken(userInfo);
        } catch (error) {
          console.error("Error handling token:", error);
          NotificationManager.error(
            "An error occurred during login. Please try again.",
            "",
            5000
          );
          handleLogOut();
        }
      })();
    }
  }, [isAuthenticated, userInfo]);

  return (
    <Page>
      <HeaderComponent handleLogin={handleLogin} showLogo={false} />
      <Hero>
        <HeroImage src={BannerHome} alt="TP Trust&Safety banner" />
      </Hero>
      <MainSection>
        <Container>
          <LogoImage src={tnsLogo} alt="TP Trust&Safety" />
          <Subtitle>
            Wellness, community and interactions: Welcome to the TnS universe,
            we invite you to explore each module designed for your well-being...
          </Subtitle>
          <ModulesGrid>
            {moduleButtons.map((m) => {
              const recordObj = JSON.parse(m.value);
              return (
                <CardComponent
                  key={m.keyConfigurationValues || recordObj.id}
                  title={recordObj.text}
                  description={recordObj.description}
                  video={recordObj.video}
                  id={recordObj.id}
                  handleShowVideo={handleShowVideo}
                />
              );
            })}
          </ModulesGrid>
        </Container>
      </MainSection>

      {loadingConfiguration && <ModalLoader />}
      {videoSource && (
        <PortalModal>
          <VideoComponent
            source={videoSource}
            handleHideVideo={setVideoSource}
          />
        </PortalModal>
      )}
    </Page>
  );
};

export default withAITracking(ai.reactPlugin, LandingPageContainer);
